import type { QueryKey } from '@tanstack/react-query';

export const staticQueryPolicy = {
  staleTime: 10 * 60_000,
  refetchInterval: false as const,
  refetchOnWindowFocus: true as const,
};

export const referenceQueryPolicy = {
  staleTime: 60 * 60_000,
  refetchInterval: false as const,
  refetchOnWindowFocus: true as const,
};

export const historyQueryPolicy = {
  staleTime: 5 * 60_000,
  refetchInterval: false as const,
  refetchOnWindowFocus: true as const,
};

export const OPERATIONAL_POLL_INTERVAL_MS = 30_000;

export const operationalQueryPolicy = {
  staleTime: 15_000,
  refetchInterval: OPERATIONAL_POLL_INTERVAL_MS,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: 'always' as const,
};

export const globalBadgeQueryPolicy = {
  staleTime: 30_000,
  refetchInterval: 60_000,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: 'always' as const,
};

/** Retain rows only when the page segment is the sole query-key change. */
export function safePagePlaceholder<T>(queryKey: QueryKey, pageIndex: number) {
  return (
    previousData: T | undefined,
    previousQuery: { queryKey: readonly unknown[] } | undefined,
  ): T | undefined => {
    if (!previousQuery || previousQuery.queryKey.length !== queryKey.length) return undefined;
    const sameScope = queryKey.every(
      (segment, index) => index === pageIndex || Object.is(segment, previousQuery.queryKey[index]),
    );
    return sameScope ? previousData : undefined;
  };
}
